<!-- View DialogGroupUseWarning -->
<template>
  <ItemDialog ref="groupUseWarning" image-type="alert">
    <template #content-area>
      <div class="text-center">
        <p>このチケットはEMotオンラインチケット（ウェブサイト）のみで利用できます。<br />恐れ入りますがEMotアプリでの利用はできませんので、EMotオンラインチケット（ウェブサイト）からご利用ください。</p>
      </div>
    </template>
    <template #button-area>
      <ItemButton
        label="OK"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogGroupUseWarning",

  setup() {
    const groupUseWarning = ref(null);

    const openDialog = () => {
      groupUseWarning.value.open();
    };

    const closeDialog = () => {
      groupUseWarning.value.close();
    };

    return {
      groupUseWarning,
      openDialog,
      closeDialog,
    };
  },
};
</script>

<style scoped lang="scss">
.text-center {
  text-align: center;
  font-size: 3vw;
}
</style>
